export default function getPreviousTodoId(itemId: string, taskIds: string[]): string | null {
    const currentIndex = taskIds.indexOf(itemId);
    if (currentIndex <= 0) {
        return null;
    }

    return taskIds[currentIndex - 1];
}
